import React from 'react';
import { AuthData } from '../../context/auth';
import { PolicyData } from '../../context/policy';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import NewInvoicesTable from '../NewInvoicesTable';

interface Props {
	premiumReportData: PremiumReportData;
	authData: AuthData;
	policyData: PolicyData;
}

const InvoicesView = (props: Props) => {
	const { premiumReportData, policyData } = props;

	return (
		<>
			<NewInvoicesTable
				invoices={[premiumReportData?.premiumReport?.invoice]}
				policyholderLocator={
					policyData && policyData.policy
						? policyData.policy.policyholderLocator
						: null
				}
				currency={policyData?.policy?.currency}
			/>
		</>
	);
};

export default withPremiumReportContext<Props>(InvoicesView);
